export const getCatalogInitialState = {
	catalogs: null,
	error: null,
	errorShow: false,
	loading: false,
};
